// extracted by mini-css-extract-plugin
module.exports = {"component":"quES0","tooltip":"_3s17x"};